import script from "./Recovery.vue?vue&type=script&setup=true&lang=js"
export * from "./Recovery.vue?vue&type=script&setup=true&lang=js"

import "./Recovery.vue?vue&type=style&index=0&id=0241dd3d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0241dd3d"]])

export default __exports__